"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _styled = require("./styled.fancyFooter");

var _defaultProps = require("./defaultProps");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _baseHelper = require("../../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

var _inlineDiv = require("../../../inlineDiv");

var _inlineDiv2 = _interopRequireDefault(_inlineDiv);

var _boxiconsLogos = require("@styled-icons/boxicons-logos");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropValue = _baseHelper2.default.getPropValue;


var FancyFooter = function FancyFooter(props) {
  var newProps = _extends({}, _defaultProps2.default.props, props);
  var content = newProps.content,
      isEditMode = newProps.isEditMode,
      media = newProps.media,
      setData = newProps.setData,
      style = newProps.style,
      updateProps = newProps.updateProps;

  // Knobs
  // Footer about column

  var logoImage = getPropValue("text", "logo", media.logo, "media");
  var altText = getPropValue("text", "altText", media.altText, "media");

  var aboutDescription1 = getPropValue("text", "shortInfo1", content.shortInfo1, "shortInfo");
  var aboutDescription2 = getPropValue("text", "shortInfo2", content.shortInfo2, "shortInfo");

  // Address Text column
  var addressTitle = getPropValue("text", "title", content.address, "address");
  var street = getPropValue("text", "street", content.street, "address");
  var building = getPropValue("text", "building", content.building, "address");
  var city = getPropValue("text", "city", content.city, "address");
  var country = getPropValue("text", "country", content.country, "address");

  // Social links
  var size = getPropValue("text", "size", style.iconSize, "social links");
  var iconHoverColor = getPropValue("text", "iconHoverColor", style.iconHoverColor, "social links");

  var socialLinksTitle = getPropValue("text", "title", content.followUs, "social links");

  var facebookUrl = getPropValue("text", "facebookUrl", content.facebookUrl, "social links");

  var twitterUrl = getPropValue("text", "twitterUrl", content.twitterUrl, "social links");

  var footerStyle = {
    textColor: getPropValue("text", "textColor", style.textColor, "style"),
    footerBackground: getPropValue("text", "footerBackground", style.footerBackground, "style")
  };
  return _react2.default.createElement(
    _styled.Footer,
    _extends({ className: "py-md-5" }, footerStyle),
    _react2.default.createElement(
      _reactBootstrap.Container,
      { className: "footer-container" },
      _react2.default.createElement(
        _reactBootstrap.Row,
        null,
        _react2.default.createElement(
          _reactBootstrap.Col,
          { sm: 4, className: "pr-md-4" },
          !!logoImage && _react2.default.createElement(
            "span",
            { className: "footer-logo d-block mb-3", to: "/" },
            _react2.default.createElement("img", { src: logoImage, alt: altText, width: "260" })
          ),
          _react2.default.createElement(_inlineDiv2.default, {
            isEditMode: isEditMode,
            keyProperty: "aboutDescription1",
            property: "content",
            setData: setData,
            updateProps: updateProps,
            value: aboutDescription1
          }),
          _react2.default.createElement(_inlineDiv2.default, {
            isEditMode: isEditMode,
            keyProperty: "aboutDescription2",
            property: "content",
            setData: setData,
            updateProps: updateProps,
            value: aboutDescription2
          })
        ),
        _react2.default.createElement(
          _reactBootstrap.Col,
          { sm: 4, className: "footer-box" },
          _react2.default.createElement(
            _styled.Title,
            { className: "text-upper mb-sm-4" },
            addressTitle
          ),
          _react2.default.createElement(
            "address",
            null,
            _react2.default.createElement(_inlineDiv2.default, {
              isEditMode: isEditMode,
              keyProperty: "street",
              property: "content",
              setData: setData,
              updateProps: updateProps,
              value: street
            }),
            _react2.default.createElement("br", null),
            _react2.default.createElement(_inlineDiv2.default, {
              isEditMode: isEditMode,
              keyProperty: "building",
              property: "content",
              setData: setData,
              updateProps: updateProps,
              value: building
            }),
            _react2.default.createElement("br", null),
            _react2.default.createElement(_inlineDiv2.default, {
              isEditMode: isEditMode,
              keyProperty: "city",
              property: "content",
              setData: setData,
              updateProps: updateProps,
              value: city
            }),
            _react2.default.createElement("br", null),
            _react2.default.createElement(_inlineDiv2.default, {
              isEditMode: isEditMode,
              keyProperty: "country",
              property: "content",
              setData: setData,
              updateProps: updateProps,
              value: country
            })
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Col,
          { sm: 4, className: "footer-box" },
          _react2.default.createElement(
            _styled.Title,
            { className: "text-upper mb-sm-4" },
            socialLinksTitle
          ),
          _react2.default.createElement(
            _styled.SocialIcons,
            _extends({
              className: "social-icons d-inline-block align-top",
              href: facebookUrl
            }, iconHoverColor),
            _react2.default.createElement(_boxiconsLogos.Facebook, { size: size })
          ),
          _react2.default.createElement(
            _styled.SocialIcons,
            _extends({
              className: "social-icons d-inline-block mx-4 mx-lg-5 align-top",
              href: twitterUrl
            }, iconHoverColor),
            _react2.default.createElement(_boxiconsLogos.Twitter, { size: size })
          )
        )
      )
    )
  );
};
exports.default = FancyFooter;